/*! JointJS+ v4.1.0 - HTML5 Diagramming Framework

Copyright (c) 2024 client IO

 2024-12-04


This Source Code Form is subject to the terms of the JointJS+ License
, v. 2.0. If a copy of the JointJS+ License was not distributed with this
file, You can obtain one at https://www.jointjs.com/license
 or from the JointJS+ archive as was distributed by client IO. See the LICENSE file.*/



 const BORDER_COLOR = '#374151';
 const options = {
     colorPalette: [
         { content: 'transparent', icon: 'assets/jointjs/transparent-icon.svg' },
         { content: '#000000' },
         { content: '#1B1B1B' },
         { content: '#353535' },
         { content: '#626262' },
         { content: '#D4D4D4' },
         { content: '#E4ECF7' },
         { content: '#FFFFFF' },
         { content: '#F5242C' },
         { content: '#7E4AD3' },
         { content: '#FB54A9' },
         { content: '#33B6D1' },
         { content: '#2A3A4E' },
         { content: '#3771B8' },
         { content: '#F27F31' },
         { content: '#1CA25D' }
     ],
 
     colorPaletteReset: [
         { content: 'transparent', icon: 'assets/no-color-icon.svg' },
         { content: '#000000' },
         { content: '#1B1B1B' },
         { content: '#353535' },
         { content: '#626262' },
         { content: '#D4D4D4' },
         { content: '#E4ECF7' },
         { content: '#FFFFFF' },
         { content: '#F5242C' },
         { content: '#7E4AD3' },
         { content: '#FB54A9' },
         { content: '#33B6D1' },
         { content: '#2A3A4E' },
         { content: '#3771B8' },
         { content: '#F27F31' },
         { content: '#1CA25D' }
     ],
 
     fontSize: Array.from({ length: 46 }, (_, i) => ({
         value: `${i + 5}px`,
         content: `<span style="font-weight: Normal;">${i + 5}</span>`
     })),
 
     fontWeight: [
         { value: '300', content: '<span style="font-weight: 300">Light</span>' },
         { value: 'Normal', content: '<span style="font-weight: Normal">Normal</span>' },
         { value: 'Bold', content: '<span style="font-weight: Bolder">Bold</span>' }
     ],
 
     textDecoration: [
         { value: 'none', content: '<span style="font-weight: 300; text-decoration: none;">None</span>'},
         { value: 'underline', content: '<span style="font-weight: 300; text-decoration: underline;">Underline</span>' },
         { value: 'overline', content: '<span style="font-weight: 300; text-decoration: overline;">Overline</span>' },
         { value: 'line-through', content: '<span style="font-weight: 300; text-decoration: line-through;">Line-through</span>' }
     ],
 
     fontStyle: [
         { value: 'normal', content: '<span style="font-weight: 300; font-style: normal">Normal</span>' },
         { value: 'italic', content: '<span style="font-weight: 300; font-style: italic">Italic</span>' },
         { value: 'oblique', content: '<span style="font-weight: 300; font-style: oblique">Oblique</span>' }
     ],
 
     fontFamily: [
         { value: 'Open Sans', content: '<span style="font-family: Open Sans">Open Sans</span>' },
         { value: 'DM Sans', content: '<span style="font-family: DM Sans">DM Sans</span>' },
         { value: 'Roboto Flex', content: '<span style="font-family: Roboto Flex">Roboto Flex</span>' }
     ],
 
     textAnchor: [
         { value: 'end', content: '<span style="font-weight: Normal">Left</span>' },
         { value: 'middle', content: '<span style="font-weight: Normal">Center</span>' },
         { value: 'start', content: '<span style="font-weight: Normal">Right</span>' }
     ],
 
     textVerticalAnchor: [
         { value: 'bottom', content: '<span style="font-weight: Normal">Top</span>' },
         { value: 'middle', content: '<span style="font-weight: Normal">Middle</span>' },
         { value: 'top', content: '<span style="font-weight: Normal">Bottom</span>' }
     ],
 
     align: [
         { value: 'left', content: '<span style="font-weight: Normal">Left</span>' },
         { value: 'center', content: '<span style="font-weight: Normal">Center</span>' },
         { value: 'right', content: '<span style="font-weight: Normal">Right</span>' }
     ],
 
     valign: [
         { value: 'flex-start', content: '<span style="font-weight: Normal">Top</span>' },
         { value: 'center', content: '<span style="font-weight: Normal">Middle</span>' },
         { value: 'flex-end', content: '<span style="font-weight: Normal">Bottom</span>' }
     ],
 
     strokeStyle: [
         { value: '0', content: 'Solid' },
         { value: '2,5', content: 'Dotted' },
         { value: '10,5', content: 'Dashed' }
     ],
 
     side: [
         { value: 'top', content: 'Top Side' },
         { value: 'right', content: 'Right Side' },
         { value: 'bottom', content: 'Bottom Side' },
         { value: 'left', content: 'Left Side' }
     ],
 
     portLabelPositionRectangle: [
         { value: { name: 'top', args: { y: -12 }}, content: 'Above' },
         { value: { name: 'right', args: { y: 0 }}, content: 'On Right' },
         { value: { name: 'bottom', args: { y: 12 }}, content: 'Below' },
         { value: { name: 'left', args: { y: 0 }}, content: 'On Left' }
     ],
 
     portLabelPositionEllipse: [
         { value: 'radial', content: 'Horizontal' },
         { value: 'radialOriented', content: 'Angled' }
     ],
 
     imageIcons: [
         { value: 'assets/jointjs/image-icon1.svg', content: '<img height="42px" src="assets/jointjs/image-icon1.svg"/>' },
         { value: 'assets/jointjs/image-icon2.svg', content: '<img height="80px" src="assets/jointjs/image-icon2.svg"/>' },
         { value: 'assets/jointjs/image-icon3.svg', content: '<img height="80px" src="assets/jointjs/image-icon3.svg"/>' },
         { value: 'assets/jointjs/image-icon4.svg', content: '<img height="80px" src="assets/jointjs/image-icon4.svg"/>' }
     ],
 
     imageGender: [
         { value: 'assets/member-male.png', content: '<img height="50px" src="assets/member-male.png" style="margin: 5px 0 0 2px;"/>' },
         { value: 'assets/member-female.png', content: '<img height="50px" src="assets/member-female.png" style="margin: 5px 0 0 2px;"/>' }
     ],
 
     arrowheadSize: [
         { value: 'M 0 0 0 0', content: 'None' },
         { value: 'M 0 -3 -6 0 0 3 z', content: 'Small' },
         { value: 'M 0 -5 -10 0 0 5 z', content: 'Medium' },
         { value: 'M 0 -10 -15 0 0 10 z', content: 'Large' },
     ],
 
     strokeWidth: [
         { value: 1, content: `<div style="background:${BORDER_COLOR};width:2px;height:30px;margin:0 14px;border-radius: 2px;"/>` },
         { value: 2, content: `<div style="background:${BORDER_COLOR};width:4px;height:30px;margin:0 13px;border-radius: 2px;"/>` },
         { value: 4, content: `<div style="background:${BORDER_COLOR};width:8px;height:30px;margin:0 11px;border-radius: 2px;"/>` },
         { value: 8, content: `<div style="background:${BORDER_COLOR};width:16px;height:30px;margin:0 8px;border-radius: 2px;"/>` }
     ],
 
     router: [
         {
             value: 'normal',
             content: `<p style="background:${BORDER_COLOR};width:2px;height:30px;margin:0 14px;border-radius: 2px;"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Normal',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         },
         {
             value: 'orthogonal',
             content: `<p style="width:20px;height:30px;margin:0 5px;border-bottom: 2px solid ${BORDER_COLOR};border-left: 2px solid ${BORDER_COLOR};"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Orthogonal',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         },
         {
             value: 'rightAngle',
             content: `<p style="width:20px;height:30px;margin:0 5px;border: 2px solid ${BORDER_COLOR};border-top: none;"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Right Angle',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         }
     ],
 
     connector: [
         {
             value: 'normal',
             content: `<p style="width:20px;height:20px;margin:5px;border-top:2px solid ${BORDER_COLOR};border-left:2px solid ${BORDER_COLOR};"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Normal',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         },
         {
             value: 'rounded',
             content: `<p style="width:20px;height:20px;margin:5px;border-top-left-radius:30%;border-top:2px solid ${BORDER_COLOR};border-left:2px solid ${BORDER_COLOR};"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Rounded',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         },
         {
             value: 'smooth',
             content: `<p style="width:20px;height:20px;margin:5px;border-top-left-radius:100%;border-top:2px solid ${BORDER_COLOR};border-left:2px solid ${BORDER_COLOR};"/>`,
             attrs: {
                 '.select-button-group-button': {
                     'data-tooltip': 'Smooth',
                     'data-tooltip-position': 'right',
                     'data-tooltip-position-selector': '.inspector-container'
                 }
             }
         }
     ],
 
     labelPosition: [
         { value: 30, content: 'Close to source' },
         { value: 0.5, content: 'In the middle' },
         { value: -30, content: 'Close to target' },
     ],
 
     portMarkup: [{
         value: [{
             tagName: 'rect',
             selector: 'portBody',
             attributes: {
                 'width': 20,
                 'height': 20,
                 'x': -10,
                 'y': -10
             }
         }],
         content: 'Rectangle'
     }, {
         value: [{
             tagName: 'circle',
             selector: 'portBody',
             attributes: {
                 'r': 10
             }
         }],
         content: 'Circle'
     }, {
         value: [{
             tagName: 'path',
             selector: 'portBody',
             attributes: {
                 'd': 'M -10 -10 10 -10 0 10 z'
             }
         }],
         content: 'Triangle'
     }],
 
     customProperties: [
         { value: '', content: 'Select opportunity type' },
         { value: 'AI Transformation Opportunity', content: 'AI Transformation Opportunity' },
         { value: 'Digital Transformation Opportunity', content: 'Digital Transformation Opportunity' },
         { value: 'Efficiency Opportunity', content: 'Efficiency Opportunity' },
         { value: 'Innovation Opportunity', content: 'Innovation Opportunity' },
         { value: 'Other Opportunity', content: 'Other Opportunity' }
     ]
 };
 
 const style = {
   alignItems: {
       type: 'select-box',
       options: options.valign,
       placeholder: 'Select',
       label: 'Vertical Alignment',
       group: 'text',
       index: 5
   }
 }
 
 const customPropertyInput = {
     type: 'select-box',
     options: options.customProperties,
     label: 'Opportunity Type',
     group: 'customProperties',
     index: 1,
     placeholder: 'Select opportunity type'
 };
 
 export const inspectorDefinitions: Record<string, { inputs: any, groups: any }> = {
     'app.Link': {
         inputs: {
             attrs: {
                 line: {
                     strokeWidth: {
                         type: 'select-button-group',
                         options: options.strokeWidth,
                         group: 'connection',
                         label: 'Link thickness',
                         when: { ne: { 'attrs/line/stroke': 'transparent' }},
                         index: 5
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         group: 'connection',
                         label: 'Link style',
                         when: { ne: { 'attrs/line/stroke': 'transparent' }},
                         index: 6
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         group: 'connection',
                         label: 'Fill',
                         index: 7
                     },
                     sourceMarker: {
                         d: {
                             type: 'select-box',
                             options: options.arrowheadSize,
                             group: 'marker-source',
                             label: 'Source arrowhead',
                             index: 1
                         },
                         fill: {
                             type: 'color',
                             options: options.colorPaletteReset,
                             group: 'marker-source',
                             label: 'Fill',
                             when: { ne: { 'attrs/line/sourceMarker/d': 'M 0 0 0 0' }},
                             index: 2
                         }
                     },
                     targetMarker: {
                         d: {
                             type: 'select-box',
                             options: options.arrowheadSize,
                             group: 'marker-target',
                             label: 'Target arrowhead',
                             index: 1
                         },
                         fill: {
                             type: 'color',
                             options: options.colorPaletteReset,
                             group: 'marker-target',
                             label: 'Fill',
                             when: { ne: { 'attrs/line/targetMarker/d': 'M 0 0 0 0' }},
                             index: 2
                         }
                     }
                 }
             },
             router: {
                 name: {
                     type: 'select-button-group',
                     options: options.router,
                     group: 'connection',
                     label: 'Connection type',
                     index: 1
                 },
                 args: {
                     sourceDirection: {
                         type: 'select-box',
                         options: options.side,
                         placeholder: 'Pick a side',
                         group: 'connection',
                         label: 'Source anchor side',
                         when: { eq: { 'router/name': 'rightAngle' }, otherwise: { unset: true }},
                         index: 2
                     },
                     targetDirection: {
                         type: 'select-box',
                         options: options.side,
                         placeholder: 'Pick a side',
                         group: 'connection',
                         label: 'Target anchor side',
                         when: { eq: { 'router/name': 'rightAngle' }, otherwise: { unset: true }},
                         index: 3
                     }
                 }
             },
             connector: {
                 name: {
                     type: 'select-button-group',
                     options: options.connector,
                     group: 'connection',
                     label: 'Connection style',
                     index: 4
                 }
             },
             labels: {
                 type: 'list',
                 group: 'labels',
                 label: 'Labels',
                 attrs: {
                     label: {
                         'data-tooltip': 'Set (possibly multiple) labels for the link',
                         'data-tooltip-position': 'right',
                         'data-tooltip-position-selector': '.joint-inspector'
                     }
                 },
                 item: {
                     type: 'object',
                     properties: {
                         attrs: {
                             text: {
                                 text: {
                                     type: 'content-editable',
                                     label: 'text',
                                     defaultValue: 'label',
                                     index: 1,
                                     attrs: {
                                         label: {
                                             'data-tooltip': 'Set text of the label',
                                             'data-tooltip-position': 'right',
                                             'data-tooltip-position-selector': '.joint-inspector'
                                         }
                                     }
                                 },
                                 fill: {
                                     type: 'color',
                                     options: options.colorPaletteReset,
                                     defaultValue: '#353535',
                                     label: 'Text Color',
                                     index: 5
                                 }
                             },
                             rect: {
                                 fill: {
                                     type: 'color',
                                     options: options.colorPaletteReset,
                                     defaultValue: '#FFFFFF',
                                     label: 'Fill',
                                     index: 3
                                 },
                                 stroke: {
                                     type: 'color',
                                     options: options.colorPaletteReset,
                                     defaultValue: '#353535',
                                     label: 'Outline',
                                     index: 4
                                 }
                             }
                         },
                         position: {
                             type: 'select-box',
                             options: options.labelPosition || [],
                             selectBoxOptionsClass: 'list-select-box',
                             defaultValue: 0.5,
                             label: 'Position',
                             placeholder: 'Custom',
                             index: 2,
                             attrs: {
                                 label: {
                                     'data-tooltip': 'Position the label relative to the source of the link',
                                     'data-tooltip-position': 'right',
                                     'data-tooltip-position-selector': '.joint-inspector'
                                 }
                             }
                         }
                     }
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             connection: {
                 label: 'Connection',
                 index: 1
             },
             'marker-source': {
                 label: 'Source marker',
                 index: 2
             },
             'marker-target': {
                 label: 'Target marker',
                 index: 3
             },
             labels: {
                 label: 'Labels',
                 index: 4
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 5
             }
         }
     },
     'app.Line': {
         inputs: {
             attrs: {
                 line: {
                     strokeWidth: {
                         type: 'select-button-group',
                         options: options.strokeWidth,
                         group: 'connection',
                         label: 'Link thickness',
                         when: { ne: { 'attrs/line/stroke': 'transparent' }},
                         index: 5
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         placeholder: 'Solid',
                         group: 'connection',
                         label: 'Link style',
                         when: { ne: { 'attrs/line/stroke': 'transparent' }},
                         index: 6
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         group: 'connection',
                         label: 'Fill',
                         index: 7
                     },
                     sourceMarker: {
                         d: {
                             type: 'select-box',
                             options: options.arrowheadSize,
                             placeholder: 'None',
                             group: 'marker-source',
                             label: 'Source arrowhead',
                             index: 1
                         },
                         fill: {
                             type: 'color',
                             options: options.colorPaletteReset,
                             group: 'marker-source',
                             label: 'Fill',
                             when: { ne: { 'attrs/line/sourceMarker/d': 'M 0 0 0 0' }},
                             index: 2
                         }
                     },
                     targetMarker: {
                         d: {
                             type: 'select-box',
                             options: options.arrowheadSize,
                             placeholder: 'None',
                             group: 'marker-target',
                             label: 'Target arrowhead',
                             index: 1
                         },
                         fill: {
                             type: 'color',
                             options: options.colorPaletteReset,
                             group: 'marker-target',
                             label: 'Fill',
                             when: { ne: { 'attrs/line/targetMarker/d': 'M 0 0 0 0' }},
                             index: 2
                         }
                     }
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             connection: {
                 label: 'Connection',
                 index: 1
             },
             'marker-source': {
                 label: 'Source marker',
                 index: 2
             },
             'marker-target': {
                 label: 'Target marker',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'app.Rectangle': {
         inputs: {
             attrs: {
                 body: {
                   stroke: {
                       type: 'color',
                       options: options.colorPalette,
                       label: 'Outline',
                       group: 'presentation',
                       index: 3
                   },
                   strokeWidth: {
                       type: 'range',
                       min: 0,
                       max: 30,
                       step: 1,
                       unit: 'px',
                       label: 'Outline thickness',
                       group: 'presentation',
                       when: { ne: { 'attrs/body/stroke': 'transparent' }},
                       index: 4
                   },
                   strokeDasharray: {
                       type: 'select-box',
                       options: options.strokeStyle,
                       label: 'Outline style',
                       group: 'presentation',
                       when: {
                           and: [
                               { ne: { 'attrs/body/stroke': 'transparent' }},
                               { ne: { 'attrs/body/strokeWidth': 0 }}
                           ]
                       },
                       index: 5
                   }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 2
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 3
             }
         }
     },
     'standard.Rectangle': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 3
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 4
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 5
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Ellipse': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/stroke-width': 0 }}
                             ]
                         },
                         index: 4
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Polygon': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Polyline': {
         inputs: {
             attrs: {
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Thickness',
                         group: 'presentation',
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Style',
                         group: 'presentation',
                         when: { ne: { 'attrs/line/strokeWidth': 0 }},
                         index: 4
                     }
                 },
                 label: {
                     text: {
                         type: 'content-editable',
                         label: 'Text',
                         group: 'text',
                         index: 1
                     },
                     fontSize: {
                         type: 'range',
                         min: 5,
                         max: 80,
                         unit: 'px',
                         label: 'Font size',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 2
                     },
                     fontFamily: {
                         type: 'select-box',
                         options: options.fontFamily,
                         label: 'Font family',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 3
                     },
                     fontWeight: {
                         type: 'select-box',
                         options: options.fontWeight,
                         label: 'Font thickness',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 4
                     },
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Text Color',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 5
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Path': {
         inputs: {
             attrs: {
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Thickness',
                         group: 'presentation',
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Style',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/strokeWidth': 0 }},
                         index: 4
                     }
                 },
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Image': {
         inputs: {
             attrs: {
                 label: {
                     text: {
                         type: 'content-editable',
                         label: 'Text',
                         group: 'text',
                         index: 1
                     },
                     fontSize: {
                         type: 'range',
                         min: 5,
                         max: 80,
                         unit: 'px',
                         label: 'Font size',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 2
                     },
                     fontFamily: {
                         type: 'select-box',
                         options: options.fontFamily,
                         label: 'Font family',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 3
                     },
                     fontWeight: {
                         type: 'select-box',
                         options: options.fontWeight,
                         label: 'Font thickness',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 4
                     },
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Text Color',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 5
                     }
                 },
                 image: {
                     xlinkHref: {
                         type: 'image-picker',
                         label: 'Image',
                         group: 'presentation',
                         index: 1
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.EmbeddedImage': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 },
                 image: {
                     xlinkHref: {
                         type: 'image-picker',
                         label: 'Image',
                         group: 'presentation',
                         index: 5
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.HeaderedRectangle': {
         inputs: {
             attrs: {
                 header: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'header',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'header',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'header',
                         when: { ne: { 'attrs/header/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'header',
                         when: {
                             and: [
                                 { ne: { 'attrs/header/stroke': 'transparent' }},
                                 { ne: { 'attrs/header/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 },
                 richTextHeader: {
                   content: {
                     type: 'rich-text',
                     label: 'Text',
                     group: 'headerText',
                     index: 1
                   }
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'body',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'body',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'body',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'body',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 },
                 richTextBody: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'bodyText',
                       index: 1
                   }
                 },
                 textContainerBody: {
                   style: {
                     alignItems: {
                       type: 'select-box',
                       options: options.valign,
                       placeholder: 'Select',
                       label: 'Vertical Alignment',
                       group: 'bodyText',
                       index: 2
                     }
                   }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             header: {
                 label: 'Header Presentation',
                 index: 1
             },
             headerText: {
                 label: 'Header Text',
                 index: 2
             },
             body: {
                 label: 'Body Presentation',
                 index: 3
             },
             bodyText: {
                 label: 'Body Text',
                 index: 4
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 5
             },
             customProperties: {
                label: 'Custom Properties',
                index: 6
             }
         }
     },
     'standard.InscribedImage': {
         inputs: {
             attrs: {
                 label: {
                     text: {
                         type: 'content-editable',
                         label: 'Text',
                         group: 'text',
                         index: 1
                     },
                     fontSize: {
                         type: 'range',
                         min: 5,
                         max: 80,
                         unit: 'px',
                         label: 'Font size',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 2
                     },
                     fontFamily: {
                         type: 'select-box',
                         options: options.fontFamily,
                         label: 'Font family',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 3
                     },
                     fontWeight: {
                         type: 'select-box',
                         options: options.fontWeight,
                         label: 'Font thickness',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 4
                     },
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Text Color',
                         group: 'text',
                         when: { ne: { 'attrs/label/text': '' }},
                         index: 5
                     }
                 },
                 background: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'presentation',
                         index: 2
                     }
                 },
                 border: {
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 10,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/border/stroke': 'transparent' }},
                         index: 4
                     }
                 },
                 image: {
                     xlinkHref: {
                         type: 'image-picker',
                         label: 'Image',
                         group: 'presentation',
                         index: 5
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
         groups: {
             presentation: {
                 label: 'Presentation',
                 index: 1
             },
             text: {
                 label: 'Text',
                 index: 2
             },
             dimensions: {
                 label: 'Dimensions',
                 index: 3
             },
             customProperties: {
                 label: 'Custom Properties',
                 index: 4
             }
         }
     },
     'standard.Cylinder': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Color',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Outline Opacity',
                         group: 'presentation',
                         index: 3
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 },
                 top: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'top',
                         index: 1
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'top',
                         index: 2
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'top',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'top',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
          groups: {
              presentation: {
                  label: 'Presentation',
                  index: 1
              },
              top: {
                  label: 'Top',
                  index: 2
              },
              text: {
                  label: 'Text',
                  index: 3
              },
              dimensions: {
                  label: 'Dimensions',
                  index: 4
              },
              customProperties: {
                  label: 'Custom Properties',
                  index: 5
              }
          }
     },
     'standard.TextBlock': {
         inputs: {
             attrs: {
                 richText: {
                   content: {
                       type: 'rich-text',
                       html: true,
                       label: 'Text',
                       group: 'text',
                       index: 1
                   }
                 },
                 textContainer: {
                   style: style
                 },
                 body: {
                     fill: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Fill',
                         group: 'presentation',
                         index: 1
                     },
                     fillOpacity: {
                         type: 'range',
                         min: 0,
                         max: 1,
                         step: 0.1,
                         label: 'Fill Opacity',
                         group: 'presentation',
                         index: 2
                     },
                     stroke: {
                         type: 'color',
                         options: options.colorPalette,
                         label: 'Outline',
                         group: 'presentation',
                         index: 2
                     },
                     strokeWidth: {
                         type: 'range',
                         min: 0,
                         max: 30,
                         step: 1,
                         unit: 'px',
                         label: 'Outline thickness',
                         group: 'presentation',
                         when: { ne: { 'attrs/body/stroke': 'transparent' }},
                         index: 3
                     },
                     strokeDasharray: {
                         type: 'select-box',
                         options: options.strokeStyle,
                         label: 'Outline style',
                         group: 'presentation',
                         when: {
                             and: [
                                 { ne: { 'attrs/body/stroke': 'transparent' }},
                                 { ne: { 'attrs/body/strokeWidth': 0 }}
                             ]
                         },
                         index: 4
                     }
                 }
             },
             size: {
                 height: {
                     type: 'number',
                     label: 'Height',
                     group: 'dimensions',
                     when: { ne: { 'size/height': 0 }},
                     index: 1
                 },
                 width: {
                     type: 'number',
                     label: 'Width',
                     group: 'dimensions',
                     when: { ne: { 'size/width': 0 }},
                     index: 1
                 }
             },
             data: {
                 customProperty: customPropertyInput
             }
         },
          groups: {
              text: {
                  label: 'Text',
                  index: 1
              },
              presentation: {
                  label: 'Presentation',
                  index: 2
              },
              dimensions: {
                  label: 'Dimensions',
                  index: 3
              },
              customProperties: {
                  label: 'Custom Properties',
                  index: 4
              }
          }
     },
 };